"use strict";

const EventImpl = require("./Event-impl").implementation;

const CloseEventInit = require("../generated/CloseEventInit");

class CloseEventImpl extends EventImpl {}
CloseEventImpl.defaultInit = CloseEventInit.convert(undefined, undefined);

exports.implementation = CloseEventImpl;
